/*============================*/
/* Update main product image. */
/*============================*/
var switchImage = function(newImageSrc, newImage, mainImageDomEl) {
  // newImageSrc is the path of the new image in the same size as originalImage is sized.
  // newImage is Shopify's object representation of the new image, with various attributes, such as scr, id, position.
  // mainImageDomEl is the passed domElement, which has not yet been manipulated. Let's manipulate it now.
  jQuery(mainImageDomEl).parents('a').attr('href', newImageSrc.replace('_grande', '_1024x1024'));
  jQuery(mainImageDomEl).attr('src', newImageSrc);  
};

 /* Update main product image when a thumbnail is clicked. */
  /*==========================*/
  $('.product-photos-mobile .product-photo-thumb a').on('click', function(e) { 
    e.preventDefault();
    switchImage($(this).attr('href'), null, $('.product-photos-mobile .product-photo-container img')[0]);
    switchImage($(this).attr('href'), null, $('.product-photos-mobile .product-photo-container img')[1]);
  });

 /* Update main product image when a thumbnail is clicked. */
  /*==========================*/
  $('.product-photos-desktop .product-photo-thumb a').on('click', function(e) { 
    e.preventDefault();
    switchImage($(this).attr('href'), null, $('.product-photo-container img')[0]);
    switchImage($(this).attr('href'), null, $('.product-photo-container img')[1]);
  });


window.timber = window.timber || {};

timber.cacheSelectors = function () {
  timber.cache = {
    // General
    $html: $('html'),
    $body: $('body'),
    

    // Product Page
    $productImageWrap: $('#productPhoto'),
    $productImage: $('#productPhotoImg'),
    $thumbImages: $('#productThumbs').find('a.product-photo-thumb'),
    $shareButtons: $('.social-sharing'),

  };
}
timber.init = function () {
  timber.cacheSelectors();
  timber.productImageZoom();
};

// ZOOM
timber.productImageZoom = function () {
    if (!timber.cache.$productImageWrap.length) {
      return;
    };

    // Destroy zoom (in case it was already set), then set it up again
    timber.cache.$productImageWrap.trigger('zoom.destroy');
    timber.cache.$productImageWrap.addClass('image-zoom').zoom({
      url: timber.cache.$productImage.attr('data-zoom')
    })
};

$( window ).load(function() {
var windowWidth
var logoWidth
var logoHeight
var collectionGridHeight
var imageWrapWidth 
var imageWidth 
var imageWrapHeight 
var imageHeight 
var imageBigger 
var imageWider 

// ZOOM
timber.productImageZoom();

 /* header calculation */
/*==========================*/
  windowWidth = $(window).width();
  logoWidth = $("#logo img").width();
  logoHeight = $("#logo img").height();
  $("header").height(logoHeight);
  
  $(".confianza-bar").height(logoHeight);
  var bodyWidth = $('body').width();

//$("#header").removeClass("lost");

   /* modelos grid calculation */
/*==========================*/
  collectionGridHeight = $('.collection-grid .coll-image-wrap img').height();
  $('#modelos.home-collections .centerParent').height(collectionGridHeight);


if ($(window).width() < 600) {
     $(".header-row .search-form").insertAfter(".header-row.last");
    $(".search-form").addClass("searchAbsolute");

   // $(".search-form").addClass("mobile-search");
  }

if ($(window).width() > 600) {
/* Center grid images */
/*==========================*/
function parseBackgroundImage(image) {
      // collect image path
      var targetImage = image.attr("src");
      image.hide();   
      // set url path as background image of parent element
      image.parent().css({
        backgroundImage: "url("+targetImage+")",
        backgroundRepeat: "no-repeat"
      });   
    };
    //Background image iteration loop   
    $(".grid img, .product-photo-thumbs img").each(function() {
      parseBackgroundImage($(this));
    }); 
  
}

$(window).resize(function() {

    windowWidth = $(window).width();
    logoWidth = $("#logo img").width();
    logoHeight = $("#logo img").height();

    $("header").height(logoHeight);
    $(".confianza-bar").height(logoHeight);

    collectionGridHeight = $('.collection-grid .coll-image-wrap').height();
    $('.grid .centerParent').height(collectionGridHeight);

    if ($(window).width() > 600) {

        /* Center grid images */
        /*==========================*/
        function parseBackgroundImage(image) {
          // collect image path
          var targetImage = image.attr("src");
          image.hide();   
          // set url path as background image of parent element
          image.parent().css({
            backgroundImage: "url("+targetImage+")",
            backgroundRepeat: "no-repeat"
          });   
        };

        //Background image iteration loop   
        $(".grid img").each(function() {
          parseBackgroundImage($(this));
        }); 

        
    };

  if ($(window).width() < 600) {
     $(".header-row .search-form").insertAfter(".header-row.last");
    $(".search-form").addClass("searchAbsolute");
   // $(".search-form").addClass("mobile-search");
  }
  if ($(window).width() > 600) {
     $(".search-form").insertBefore("#header .cart-link");
    $(".search-form").removeClass("searchAbsolute");
   // $(".search-form").addClass("mobile-search");
  }

});

$(document).ready(function(){
  var $shareButtons = $('.social-sharing');
  // General selectors
  var $buttons = $shareButtons,
      $shareLinks = $buttons.find('a'),
      permalink = $buttons.attr('data-permalink');

  // Share button selectors
  var $fbLink = $('.share-facebook'),
      $twitLink = $('.share-twitter'),
      $pinLink = $('.share-pinterest'),
      $googleLink = $('.share-google');

  if ( $fbLink.length ) {
    $.getJSON('https://graph.facebook.com/?id=' + permalink + '&callback=?', function(data) {
      if (data.shares) {
        $fbLink.find('.share-count').text(data.shares).addClass('is-loaded');
      } else {
        $fbLink.find('.share-count').remove();
      }
    });
  };

  if ( $twitLink.length ) {
    $.getJSON('https://cdn.api.twitter.com/1/urls/count.json?url=' + permalink + '&callback=?', function(data) {
      if (data.count > 0) {
        $twitLink.find('.share-count').text(data.count).addClass('is-loaded');
      } else {
        $twitLink.find('.share-count').remove();
      }
    });
  };

  if ( $pinLink.length ) {
    $.getJSON('https://api.pinterest.com/v1/urls/count.json?url=' + permalink + '&callback=?', function(data) {
      if (data.count > 0) {
        $pinLink.find('.share-count').text(data.count).addClass('is-loaded');
      } else {
        $pinLink.find('.share-count').remove();
      }
    });
  };

  if ( $googleLink.length ) {
    // Can't currently get Google+ count with JS, so just pretend it loaded
    $googleLink.find('.share-count').addClass('is-loaded');
  };

  // Share popups
  $shareLinks.on('click', function(e) {
    e.preventDefault();
    var el = $(this),
        popup = el.attr('class').replace('-','_'),
        link = el.attr('href'),
        w = 700,
        h = 400;

    // Set popup sizes
    switch (popup) {
      case 'share-twitter':
        h = 300;
        break;
      case 'share-fancy':
        w = 480;
        h = 720;
        break;
      case 'share-google':
        w = 500;
        break;
    }

    window.open(link, popup, 'width=' + w + ', height=' + h);
  });

});

jQuery(function($) {
                    
  /* Placeholder JS */
  /*==========================*/
  var test = document.createElement('input');
  if (!('placeholder' in test)) {
    $('[placeholder]').each(function(){
      if ($(this).val() === '') {
        var hint = $(this).attr('placeholder');
        $(this).val(hint).addClass('hint');
      }
    });
    $('[placeholder]').focus(function() {
      if ($(this).val() === $(this).attr('placeholder')) {
        $(this).val('').removeClass('hint');
      }
    }).blur(function() {
      if ($(this).val() === '') {
        $(this).val($(this).attr('placeholder')).addClass('hint');
      }
    });    
  }

  /* Hamburger mobile menu */
  /*==========================*/
  $("#nav-mob").click(function(){
      $("body").toggleClass("active-nav");
      $("#nav").toggleClass("active-nav");
      $(this).toggleClass("active-nav");
      $(".header-row.last").show("fast");
  });


  /* Form validation JS */
  /*==========================*/

  $('input.error, textarea.error').focus(function() {
    $(this).removeClass('error');
  });

  $('form :submit').click(function() {
    $(this).parents('form').find('input.hint, textarea.hint').each(function() {
      $(this).val('').removeClass('hint');
    });
    return true;
  });
  
  /* Remove SVG images to avoid broken images in all browsers that don't support SVG. */
  /*==========================*/
  
  var supportsSVG = function() {
    return document.implementation.hasFeature('http://www.w3.org/TR/SVG11/feature#Image', '1.1');
  }  
  if (!supportsSVG()) {
    $('img[src*=".svg"]').remove();
  }
  
  /* Prepare to have floated images fill the width of the design on blog pages on small devices. */
  /*==========================*/ 
    
  var images = $('.article img').load(function() {
    var src = $(this).attr('src').replace(/_grande\.|_large\.|_medium\.|_small\./, '.');
    var width = $(this).width();
    $(this).attr('src', src).attr('width', width).removeAttr('height');
  });

  
});
});// Initialize Timber's JS on docready
$(timber.init)